export default __webpack_public_path__ + "static/media/expressjs-logo.39a0f4c3.png";